<template>
    <v-dialog v-model="showDialog" max-width="330px">
        <v-sheet rounded class="dialog pa-4">
            <v-img
                class=" mx-auto"
                :src="qrCode.qrCode"
                height="300"
                width="300"
            ></v-img>
            <p class="text-center mt-2">{{qrCode.lot}}</p>
        </v-sheet>
    </v-dialog>
</template>

<script>
export default {
    name: "LotQrCodeModal",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        qrCode:{
            type: Object,
            required: true,
        }
    },
    data() {
        return {
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        save() {
            this.$emit("save");
        },
    }
}
</script>

<style scoped>

</style>
